import React from "react";

const CatalogDistributionWidget: React.FC = () => {
  return (
    <div className="widget">
      <h2 className="text-lg font-bold mb-2">Catalog Distribution</h2>
      <img
        src="/images/catalog_distribution_chart.png"
        alt="Catalog Distribution Chart"
        className="w-full h-auto"
      />
    </div>
  );
};

export default CatalogDistributionWidget;
